"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.AnimationManager = void 0;
const lodash_clonedeep_1 = __importDefault(require("lodash.clonedeep"));
const Util_1 = require("../../../../engine/lib/util/Util");
class AnimationManager {
    constructor() {
        this.animations = [];
        this.frames = [];
        this.frameCount = 0;
        this.currentFrame = -1;
    }
    getFrameRef(frameIndex) {
        if (this.frames[frameIndex] === undefined) {
            const prevFrame = this.frames[frameIndex - 1];
            this.frames[frameIndex] = lodash_clonedeep_1.default(prevFrame !== null && prevFrame !== void 0 ? prevFrame : {
                bodyparts: {},
                offsets: {}
            });
        }
        return this.frames[frameIndex];
    }
    // Add and normalize animation
    add(animation) {
        animation = lodash_clonedeep_1.default(animation);
        const bodyPartsEnds = [...new Set(animation.frames.flatMap((frame) => Object.keys(frame.bodyparts)))];
        bodyPartsEnds.forEach((setType) => {
            const endIndex = animation.frames.findIndex(frame => !(setType in frame.bodyparts));
            for (let i = endIndex; i >= 0 && i < animation.frames.length; i++) {
                const frame = animation.frames[i];
                const loopFrame = animation.frames[i % endIndex];
                frame.bodyparts[setType] = loopFrame.bodyparts[setType];
            }
        }, {});
        this.animations.push(animation);
        return this;
    }
    countAnimationFrames(animation) {
        return animation.frames.reduce((acc, frame) => {
            const count = Object.values(frame.bodyparts || {})
                .reduce((max, part) => Math.max(max, Number(part.repeats || 1)), 0);
            return acc + count;
        }, 0);
    }
    nextFrame() {
        this.currentFrame = (this.currentFrame + 1) % this.frameCount;
        return this.frames[this.currentFrame];
    }
    buildFrames() {
        const animationsFrameCount = this.animations.map(this.countAnimationFrames);
        this.frameCount =
            animationsFrameCount.length > 1
                ? Util_1.lcm(...animationsFrameCount)
                : animationsFrameCount[0];
        this.frames = new Array(this.frameCount);
        this.animations.forEach(({ frames, desc }, animationIndex) => {
            const animationFrameCount = animationsFrameCount[animationIndex];
            for (let frameIndex = 0; frameIndex < this.frameCount; frameIndex += animationFrameCount) {
                let loadedFrames = 0;
                frames.forEach(({ bodyparts, offsets }) => {
                    let maxRepeat = 0;
                    for (const [setType, bodyPart] of Object.entries(bodyparts || {})) {
                        const repeat = Number(bodyPart.repeats || 1);
                        maxRepeat = Math.max(maxRepeat, repeat);
                        for (let r = 0; r < repeat; r++) {
                            const frameRefIndex = frameIndex + loadedFrames + r;
                            const frameRef = this.getFrameRef(frameRefIndex);
                            frameRef.offsets = offsets || {};
                            frameRef.bodyparts[setType] = lodash_clonedeep_1.default(bodyPart);
                        }
                    }
                    loadedFrames += maxRepeat;
                });
            }
        });
        return this;
    }
}
exports.AnimationManager = AnimationManager;
